import { ALERT_SEVERITY, ERROR_MESSAGES, ROLE_TYPE } from 'eebac/constants';
import { Catch } from '../api_exception';
import { setGlobalMessage, setLoading } from '../app';
const BASE_PATH = 'COMPANY_DASHBOARD';

export const SET_DASHBOARD_DATA = `${BASE_PATH}/SET_DASHBOARD_DATA`;

export const loadCompanyDashboardData = () =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        dispatch(setDashboardData({
            totalPosts: "",
            activePosts: "",
            meetingsCount: "",
            rfqs: "",
        }));

        client.get('/company/dashboard').
            then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess &&
                    result.data.dashboard) {
                    dispatch(setDashboardData(result.data.dashboard));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const setDashboardData = (data) => ({
    type: SET_DASHBOARD_DATA,
    data
});

const initialState = {
    totalPosts: "",
    activePosts: "",
    meetingsCount: "",
    rfqs: "",
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_DASHBOARD_DATA:
            return {
                ...state,
                totalPosts: action.data.totalPosts,
                activePosts: action.data.activePosts,
                meetingsCount: action.data.meetingsCount,
                rfqs: action.data.rfqs
            }
    }
    return state;
}